import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import ReactTooltip from "react-tooltip";

export function BookingTable() {
  const { colHeaders, columns, data, rawDataLink, dateHeaderTooltip } = useSelector(
    (state) => state.bookings.tableData
  );

  const tooltipId = "booking-date-table-header-tooltip";

  return (
    <>
      <TableWithCustomSearch
        data={data}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        fileName="bookings-table"
        noDataMessage="No data found, please update filters and try again."
        columnHeaderSlot={{
          Date: (
            <div className="d-inline" data-for={tooltipId} data-tip={dateHeaderTooltip}>
              Date
            </div>
          )
        }}
      />
      <ReactTooltip id={tooltipId} />
    </>
  );
}
